























































































































































































































import { ClaimStatusDTO, Page } from "@/model/component.model";
import {
  ClaimCategorizationDTO,
  ClaimDTO,
  ClaimErrorSubTypeDTO,
  ClaimErrorTypeDTO,
  ClaimPriorityDTO,
  SearchUserRequestDTO
} from "@/model/data.model";
import {
  getMultiStoreId,
  getStoreId,
  getTenantId
} from "@/services/AuthService";
import { ClaimService } from "@/services/ClaimService";
import {
  alertDangerReason,
  getDateFormat,
  pageToPageRequest
} from "@/services/Helpers";
import { UserService } from "@/services/UserService";
import cloneDeep from "lodash/cloneDeep";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { required } from "vuelidate/lib/validators";
import Modal from "../shared/modal/Modal.vue";

@Component({
  components: {
    MbeModal: Modal
  },
  validations() {
    return {
      claim: {
        priority: {
          required
        },
        categorization: {
          required
        },
        errorType: {
          required
        },
        errorSubtype: {
          required
        },
        description: {
          required
        },
        dueDate: {
          required
        }
      }
    };
  }
})
export default class OpenClaimModal extends Vue {
  @Prop({ type: String, required: true }) incidentId: string;
  @Prop() item: ClaimDTO;
  claim: ClaimDTO = {
    priority: "",
    dueDate: "",
    categorization: "",
    errorType: "",
    errorSubtype: "",
    assigneeId: 0,
    assigneeName: "",
    claimStatus: "",
    description: "",
    protocolNumber: null,
    notes: []
  };
  categorizations: ClaimCategorizationDTO[] = [];
  claimStatusList: ClaimStatusDTO[] = [];
  priorities: ClaimPriorityDTO[] = [];
  isUpdateClaim = false;
  errorTypes: ClaimErrorTypeDTO[] = [];
  errorSubTypes: ClaimErrorSubTypeDTO[] = [];
  claimStatusReadOnly = false;

  @Watch("claim.errorType")
  onClaimErrorTypeChange(newValue: string) {
    this.loadErrorSubTypes(newValue);
  }

  @Watch("item", { deep: true, immediate: true })
  onItemChange() {
    if (!this.item || !this.item.description.length) {
      this.isUpdateClaim = false;
      return;
    }
    this.isUpdateClaim = true;
    this.claim = cloneDeep(this.item);
  }

  async loadClaimStatuses() {
    try {
      this.claimStatusList = (await ClaimService.getClaimStatusList())
        .filter((item: ClaimStatusDTO) => {
          return item.active;
        })
        .sort((a: ClaimStatusDTO, b: ClaimStatusDTO) => {
          return a.description.localeCompare(b.description);
        });
    } catch (err) {
      console.error(err);
    }
  }

  async loadCategorization() {
    try {
      this.categorizations = await ClaimService.getClaimCategorization();
    } catch (err) {
      //nothing to do here
    }
  }

  async loadPriority() {
    try {
      this.priorities = await ClaimService.getClaimPriorities();
    } catch (err) {
      //nothing to do here
    }
  }

  async loadErrorSubTypes(errorType: string) {
    try {
      this.errorSubTypes = await ClaimService.getClaimErrorSubTypes(errorType);
    } catch (err) {
      //nothing to do here
    }
  }

  async loadErrorTypes() {
    try {
      this.errorTypes = await ClaimService.getClaimErrorTypes();
    } catch (err) {
      //nothing to do here
    }
  }

  async init() {
    await this.loadCategorization();
    await this.loadErrorTypes();
    await this.loadPriority();
    await this.loadClaimStatuses();
  }

  async created() {
    await this.init();
  }

  initDefaultStatus() {
    const foundElement = this.claimStatusList.find(
      (el: ClaimStatusDTO) => el.defaultStatus
    );
    if (!foundElement) return;
    this.claim.claimStatus = foundElement.description;
    this.claimStatusReadOnly = true;
  }

  get canInitDefaultStatus() {
    if (this.isUpdateClaim) return false;
    if (!this.claimStatusList.length) return false;
    return true;
  }

  @Watch("canInitDefaultStatus", { immediate: true })
  onCanInitDefaultStatusChange(status: boolean) {
    if (!status) {
      this.claimStatusReadOnly = false;
    } else {
      this.initDefaultStatus();
    }
  }

  get disableSaveBtn() {
    return this.$v.$invalid;
  }

  datePickerOptions() {
    const date = new Date();
    const options = {
      shortcuts: [
        {
          text: this.$i18n.t("today"),
          onClick(picker: any) {
            picker.$emit("pick", new Date());
          }
        },
        {
          text: this.$i18n.t("first_day_month"),
          onClick(picker: any) {
            picker.$emit(
              "pick",
              new Date(date.getFullYear(), date.getMonth(), 1)
            );
          }
        }
      ],
      firstDayOfWeek: 1
      // disabledDate(time: any) {
      // 	return time.getTime() < (new Date(new Date().setDate(new Date().getDate()-1))).getTime();
      // }
    } as any;

    return options;
  }

  get modalTitle() {
    if (this.isUpdateClaim) return this.$i18n.t("CLAIM_UPDATE_MODAL_TITLE");
    return this.$i18n.t("CLAIM_OPEN_CLAIM_MODAL_TITLE");
  }

  async save() {
    try {
      await ClaimService.openClaim(this.incidentId, this.claim);
      this.$emit("saved", this.claim);
    } catch (err) {
      await alertDangerReason(err, this);
    }
  }

  closeModal() {
    this.$emit("closeModal", false);
  }

  get dateFormat() {
    return getDateFormat();
  }
}
